import React, { useEffect } from 'react'
import { useReports } from '../../hooks/useReports'
import { Container } from 'react-bootstrap';
import PageTitle from '../shared/PageTitle';
import Message from '../shared/Message';
import ReportForm from '../forms/ReportForm';
import CustomLoader from '../shared/CustomLoader';
import ReportsTable from '../tables/ReportsTable';

const Reports = () => {
    const {
        reports,
        report,
        loading,
        isSaving,
        message,
        setMessage,
        fetchReports,
        getReport,
        storeReport,
        updateReport,
        deleteReport
    } = useReports();

    // Load data on mount 
    useEffect(() => {
        fetchReports();
    }, [fetchReports]);

    // This handles both Create and Update seamlessly 
    const handleSaveReport = async (data) => {
        try {
            if (data.id) {
                await updateReport(data.id, data);
            } else {
                await storeReport(data);
            }

            return true; // Triggers resetForm() in ReportForm.jsx
        } catch (error) {
            // 422 errors are caught and thrown to ReportForm.jsx 
            // Generic errors are handled by setMessage(handleError((error)) in the hook 
            // If it's a validation error, re-throw it so ReportForm can catch it
            if (error.response?.status === 422) {
                throw error; 
            }
            
            return false 
        }
    };

  return (
    <Container fluid>

        <PageTitle title='Report Details' />

        {/** Hook-managed message state */}
        <Message 
            show={message?.show}
            message={message?.text}
            variant={message?.variant}
            handleClose={() => setMessage({...message, show: false})}
        />

        {/** UI Collector for data */}
        <ReportForm
            isSaving={isSaving}
            report={report}
            formAction={handleSaveReport}
        />

        <hr className="my-5" />

        {/** Conditional Rendering using hook states */}
        {loading && reports.length === 0 ? (
            <CustomLoader />
        ) :(
            <ReportsTable 
                reports={reports}
                onEdit={getReport}
                onDelete={deleteReport}
            />
        )}
    </Container>
  )
}

export default Reports